@let s = section();
<section class="lk-section" [attr.data-test-id]="testIdPrefix() + '-section-' + sectionKey()">
  <h4>{{ s.title }}</h4>

  @if (s.facts.length > 0) {
    <dl class="lk-section__facts" [attr.data-test-id]="testIdPrefix() + '-facts-' + sectionKey()">
      @for (fact of s.facts; track $index) {
        <div class="lk-section__fact">
          <dt><ng-container *ngTemplateOutlet="richText; context: { $implicit: fact.label }" /></dt>
          <dd><ng-container *ngTemplateOutlet="richText; context: { $implicit: fact.value }" /></dd>
        </div>
      }
    </dl>
  }

  @for (paragraph of s.paragraphs; track $index) {
    <p><ng-container *ngTemplateOutlet="richText; context: { $implicit: paragraph }" /></p>
  }

  @if (s.table; as table) {
    <div class="lk-section__table-wrap" data-dock-wide-content>
      <table class="lk-section__table" [attr.data-test-id]="testIdPrefix() + '-table-' + sectionKey()">
        @if (table.caption.length > 0) {
          <caption><ng-container *ngTemplateOutlet="richText; context: { $implicit: table.caption }" /></caption>
        }
        @if (table.columns.length > 0) {
          <thead>
            <tr>
              @for (column of table.columns; track $index) {
                <th scope="col">{{ column }}</th>
              }
            </tr>
          </thead>
        }
        <tbody>
          @for (row of table.rows; track $index) {
            <tr>
              @for (cell of row; track $index) {
                <td><ng-container *ngTemplateOutlet="richText; context: { $implicit: cell }" /></td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (s.timeline.length > 0) {
    <ol class="lk-section__timeline" [attr.data-test-id]="testIdPrefix() + '-timeline-' + sectionKey()">
      @for (entry of s.timeline; track $index) {
        <li>
          <span class="lk-section__timeline-when">{{ entry.when }}</span>
          <span class="lk-section__timeline-what"><ng-container *ngTemplateOutlet="richText; context: { $implicit: entry.what }" /></span>
        </li>
      }
    </ol>
  }

  @if (s.items.length > 0) {
    @if (s.itemsAsBullets) {
      <ul class="lk-section__items lk-section__items--bullets">
        @for (item of s.items; track $index) {
          <li><ng-container *ngTemplateOutlet="richText; context: { $implicit: item }" /></li>
        }
      </ul>
    } @else {
      <ol class="lk-section__items">
        @for (item of s.items; track $index) {
          <li><ng-container *ngTemplateOutlet="richText; context: { $implicit: item }" /></li>
        }
      </ol>
    }
  }

  @if (s.closing.length > 0) {
    <p><ng-container *ngTemplateOutlet="richText; context: { $implicit: s.closing }" /></p>
  }

  @if (s.note.length > 0) {
    <blockquote class="lk-section__note">
      <ng-container *ngTemplateOutlet="richText; context: { $implicit: s.note }" />
    </blockquote>
  }

  @if (linkPanel(); as panel) {
    <hd-locks-keys-panel-link [panel]="panel" variant="inline"></hd-locks-keys-panel-link>
  }

  @if (s.sources.length > 0) {
    <div class="lk-section__sources" [attr.data-test-id]="testIdPrefix() + '-sources-' + sectionKey()">
      <span class="lk-section__sources-label">{{ sourcesLabel() }}</span>
      <ol>
        @for (source of s.sources; track $index) {
          <li>{{ source }}</li>
        }
      </ol>
    </div>
  }
</section>

<!--
  Leestekst met bronverwijzingen (`[n]` wordt een voetnootnummer) en het label
  "berekend" (`{calc}`). Bewust op één regel: losse witruimte rond de segmenten
  zou als spatie vóór elk voetnootnummer gerenderd worden.
-->
<ng-template #richText let-segments>
  @for (segment of segments; track $index) {@if (segment.isRef) {<sup class="lk-section__ref" [attr.title]="segment.refTitle">{{ segment.text }}</sup>} @else if (segment.isCalc) {<span class="lk-section__calc" [attr.title]="calcTitle()">{{ calcLabel() }}</span>} @else {<ng-container>{{ segment.text }}</ng-container>}}
</ng-template>
